(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6903],{

/***/ 2365:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/rooms/[rid]",
      function () {
        return __webpack_require__(2637);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ RoomDetail; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_DetailRoom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1716);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9536);
/* harmony import */ var _layout_FooterHotel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8078);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4850);







var __N_SSG = true;
function RoomDetail(param) {
    var header = param.header, hotelBrands = param.hotelBrands, room = param.room;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var _thumbnail, _hotel_code;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(room.meta_title_id) && router.locale == "id" ? room.meta_title_id : !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(room.meta_title_en) ? room.meta_title_en : "".concat(room.name, " - Rooms | ").concat(header.name, " | Parador Hotels & Resorts"),
                description: router.locale == "id" ? !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(room.meta_desc_id) ? room.meta_desc_id : room.desc_long_id : !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(room.meta_desc_en) ? room.meta_desc_en : room.desc_long_en,
                image: !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(room.meta_thumb) ? room.meta_thumb : room.thumbnail
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                headerItem: header,
                isHomepage: false,
                hotelBrands: hotelBrands
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_DetailRoom__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "zero",
                color: header.color_primary,
                thumb: (_thumbnail = room.thumbnail) !== null && _thumbnail !== void 0 ? _thumbnail : "",
                images: room.gallery,
                title: router.locale == "id" && !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(room.room_name_id) ? room.room_name_id : room.name,
                price: room.start_from,
                desc: router.locale == "id" ? room.desc_long_id : room.desc_long_en,
                featured: [
                    room.total_guest,
                    room.bed_type,
                    (0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(room.room_size_manual) ? room.room_size : room.room_size_manual, 
                ],
                benefits: room.benefits,
                tac: router.locale == "id" ? room.tac_id : room.tac_en,
                slug: header.slug,
                includes: router.locale == "id" ? room.stay_includes_id : room.stay_includes_en,
                headline: undefined,
                subHeadline: undefined,
                brochure: room.brochures.length ? room.brochures[0] : room.brochures,
                layout: room.layout,
                hotelCode: (_hotel_code = header.hotel_code) !== null && _hotel_code !== void 0 ? _hotel_code : ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_FooterHotel__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                hotelSlug: header.slug,
                instagram: header.instagram,
                facebook: header.facebook,
                locationLink: header.location_url,
                location: header.location_long,
                email: header.email,
                phone: header.phone,
                bg: header.color_primary,
                color: "white",
                logo: header.logo_light
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,1228,5525,6394,9996,9392,4939,8078,1716,9774,2888,179], function() { return __webpack_exec__(2365); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);